import { WidgetBase } from "./WidgetBase";
import { WidgetTypes } from "./WidgetTypes";
import { WidgetController } from "../WidgetController";
import { WidgetLinksComponent } from "../Components/WidgetLinksComponent";
import { PopupLinksComponent } from "../Popups/PopupLinksComponent";
import { LanguageString } from "../../../Model/LanguageString";
import { app } from "../../../Frame/App";
import { LinkWidgetModel } from "../Models/LinkWidgetModel";

export class WidgetLinksProps {
    public title: LanguageString;

    constructor() {
        this.title = new LanguageString();
    }
}

export class WidgetLinks extends WidgetBase {
    props: WidgetLinksProps;
    public widgetModel: LinkWidgetModel;

    constructor(controller: WidgetController) {
        super(controller, 1, 1);
        this.props = new WidgetLinksProps();
        this.widgetModel = new LinkWidgetModel();
    }

    // get all links
    getLinksData(): any {
        let data: any = [];
        $.ajax({
            type: "GET",
            url: app.resolveUrl("~/api/widget/getLinksData"),
            async: false,
            success: ((response) => {
                data = response;
            }),
            error: ((response) => {
                alert(response.statusText + ": " + response.responseText);
            })
        });

        return data;
    }

    getType(): WidgetTypes {
        return WidgetTypes.Links;
    }

    loadProps(jsonProps: string): void {
        if (jsonProps && jsonProps.length > 0) {
            this.props = JSON.parse(jsonProps);
        } else
            this.props.title = new LanguageString();
    }

    saveProps(): string {
        return JSON.stringify(this.props);
    }

    createComponent(column: number, row: number, colSpan?: number, rowSpan?: number): HTMLElement {
        this.column = column;
        this.row = row;
        this.colSpan = colSpan ? colSpan : this.minColSpan;
        this.rowSpan = rowSpan ? rowSpan : this.minRowSpan;
        this.component = new WidgetLinksComponent({
            widget: this,
            title: this.props.title
        });
        return this.component.render();
    }

    showPopup(): void {
        this.getLinksData();
        let popup = new PopupLinksComponent({ widget: this });
        document.body.appendChild(popup.render());
    }
}